export class CreateProjectAction {
  static readonly type = '[Project] Create Project';

  constructor(public project) {}
}
